module.exports = __webpack_public_path__ + "img/recommend-001.5980b7aa.png";